// extracted by mini-css-extract-plugin
module.exports = {"flag":"styles_flag__31ekB","close":"styles_close__xnPca","isOpen":"styles_isOpen__38zLi"};